import React, { useReducer, useState, useEffect } from 'react';
import { getAreas } from './sources.js';

const initialState = {
    areas: [],
};
var ActionKind;
(function (ActionKind) {
    ActionKind[ActionKind["SET_AREAS"] = 0] = "SET_AREAS";
})(ActionKind || (ActionKind = {}));
function configReducer(state, action) {
    const { type, payload } = action;
    switch (type) {
        case ActionKind.SET_AREAS: {
            return {
                ...state,
                areas: payload,
            };
        }
        default:
            return state;
    }
}
const configContext = React.createContext(initialState);
const { Provider } = configContext;
const defaultAreaFilter = () => true;
const defaultAreaMapper = area => area;
const defaultAreaSorter = (a, b) => {
    if (a.name && b.name) {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    }
    return 0;
};
const ConfigProvider = ({ children, locale = {}, areaFilter = defaultAreaFilter, areaMapper = defaultAreaMapper, areaSorter = defaultAreaSorter, }) => {
    const [state, dispatch] = useReducer(configReducer, initialState);
    const [areas, setAreas] = useState([]);
    useEffect(() => {
        setAreas(getAreas(locale));
    }, [locale]);
    useEffect(() => {
        let payload = areas
            .filter((area, index, array) => areaFilter(area, index, array))
            .map((area, index, array) => areaMapper(area, index, array));
        if (areaSorter) {
            payload = payload.sort(areaSorter); // nosonar
        }
        dispatch({ type: ActionKind.SET_AREAS, payload });
    }, [areas, areaFilter, areaMapper, areaSorter]);
    return React.createElement(Provider, { value: state }, children);
};

export { ConfigProvider, configContext };
